import React from 'react'
import { Flex, Spinner, Text } from '@chakra-ui/react'

interface LoadingStateProps {
  label?: string
}

const LoadingState: React.FC<LoadingStateProps> = ({ label = 'Loading...' }) => {
  return (
    <Flex
      h="100%"
      align="center"
      justify="center"
      direction="column"
      gap={3}
      role="status"
    >
      <Spinner colorPalette="primary" size="lg" />
      {label && <Text color="lighterText" fontSize="sm">{label}</Text>}
    </Flex>
  )
}

export default LoadingState
